import { useState, useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '@reducers/index';
import { KeywordOptimizationGridOption } from '@classes/options/grid/keyword/keywordOptimization';
import GridAtom from '@components/atom/grid/grid';
import { filterObjType } from '@models/keyword/keywordModel';
import { AllScoresSelectList } from '@models/keyword/keyword';

const CompetitorBox = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { competitorBoxList } = useSelector(({ keywordOptimization }: RootState) => keywordOptimization);
  const { keywordGroupList } = useSelector(({ keyword }: RootState) => keyword);

  // chartDataOption
  const [gridChartData, setGridChartData] = useState(null);

  // filterOption
  const [filterObj, setFilterObj] = useState<filterObjType>(null);

  // gridChartOption
  const gridOption = new KeywordOptimizationGridOption();

  // useEffect for setGridChart
  useEffect(() => {
    if (competitorBoxList) {
      setGridChartData(gridOption.competitorBox(competitorBoxList));
    }
  }, [competitorBoxList]);

  // useEffect for filterObj
  useEffect(() => {
    if (competitorBoxList) {
      if (filterObj) {
        setGridChartData(gridOption.competitorBox(competitorBoxList, filterObj));
      }
    }
  }, [filterObj]);

  // selectHandler 모든 select 변경 함수 핸들러
  const onSelectChangeHandler = useCallback((event) => {
    const { name, value } = event.target;
    let tempObj;
    switch (name) {
      case 'score':
        tempObj = { score: value };
        break;
      case 'group':
        tempObj = { group: value };
        break;
      default:
        break;
    }
    setFilterObj((prev) => ({ ...prev, ...tempObj }));
  }, []);

  return (
    <div className="competitor-kword">
      <div className="keyword-data">
        <h2 className="keyword-data-tit">Competitor's Keywords</h2>
        <div className="keyword-data-sorting">
          <label className="select">
            <select name="score" onChange={onSelectChangeHandler}>
              {AllScoresSelectList.map((item, index) => (
                <option key={index} value={item.value}>
                  {item.text}
                </option>
              ))}
            </select>
          </label>
          <label className="select">
            <select name="group" onChange={onSelectChangeHandler}>
              <option value={'All'}>Filter woth a Group</option>
              {keywordGroupList?.length > 0 &&
                keywordGroupList.map((item, index) => (
                  <option key={index} value={item.value}>
                    {item.text}
                  </option>
                ))}
            </select>
          </label>
        </div>
      </div>
      {/* 차트부분 */}
      <div className="table-api-wrap">
        <div className="table-api">
          <GridAtom {...gridChartData} height={'590px'} />
        </div>
      </div>
    </div>
  );
};

export default CompetitorBox;
